<template>
    <div>
        <div class="head-container">
            <the-tools-logo class="head-container__tools-logo"></the-tools-logo>
            <div class="head-container__title">
                Ylands Dashboard
            </div>
            <div class="head-container__description">
                Use the following shortcuts to manage your creations
            </div>
        </div>
    </div>
</template>

<script>
import TheToolsLogo from 'Svgs/dashboard_ylands_ico.svg?inline';
export default {
    name: 'SidebarHead',
    components: { TheToolsLogo },
};
</script>

<style scoped lang="scss">
.head-container {
    margin-top: 6rem;
    display: grid;
    grid-template-columns: 6.5rem 1fr;
    grid-auto-rows: 6rem 8rem;
    &__tools-logo {
        margin: auto auto auto 2rem;
        height: 81px;
    }
    &__title {
        position: relative;
        justify-self: left;
        margin-top: 1rem;
        margin-left: 1rem;
        width: 179px;
        height: 62px;
        color: $blue-main;
        font-family: $politica-font;
        font-size: 29px;
        font-weight: 700;
        letter-spacing: 1.32px;
        line-height: 31px;
    }
    &__description {
        height: 111px;
        width: 90%;
        margin: 5px auto auto 2.5rem;
        position: relative;
        grid-column: 1 / 3;
        grid-row-start: 2;
        font-family: $palanquin-font;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.88px;
        line-height: 24px;
        color: $blue-main;
        @media (max-width: $xl-up) {
            width: 280px;
        }
        @media (max-width: $lg-up) {
            width: 250px;
        }
    }
}
</style>
